<template>
  <div
    class="field"
    :class="{'field--error': showErrors}"
  >
    <label
      class="field__label"
      for="field_label"
      :for="id"
      v-text="label"
    />
    <input
      v-model="inputValue"
      class="field__input"
      type="text"
      id="field_label"
      :id="id"
      :name="id"
      v-on="listeners"
      :placeholder="placeholder"
    />
    <gc-list
      v-if="showErrors"
      :display-errors="true"
      :items="errors"
    />
  </div>
</template>

<script>
  import GcList from "./GcList";
  export default {
    name: "GcTextField",
    components: {
      GcList
    },
    props: {
      id: {
        required: true
      },
      label: {
        required: true
      },
      value: {
        required: true
      },
      placeholder: {
        default: null
      },
      validation: {
        default: {}
      }
    },

    data() {
      return {
        inputValue: this.value,
      }
    },

    computed: {
      listeners() {
        this.$listeners.input = (e) => {
          this.$emit('input', e.target.value)
        }

        return this.$listeners;
      },

      errors() {
        return this.validation.errors || [];
      },

      showErrors() {
        return this.errors.length !== 0 &&
          (this.validation.isSubmitted || this.validation.isTouched);
      }
    },

    watch: {
      value: function (value) {
        this.inputValue = value;
      },
    },
  }
</script>

<style>
  .balance-checker .field {
    margin-bottom: .5rem;
  }

  .balance-checker .field .list__items {
    padding: .5rem .75rem;
  }

  .balance-checker .field:last-child {
    margin: 0;
  }

  .balance-checker .field__label {
    display: inline-block;
    font-size: .75rem;
    padding: 0 .25rem;
    margin: 0 0 0 .5rem;
    position: relative;
    z-index: 1;
    background: #fff;
  }

  .balance-checker .field__input,
  .balance-checker .field__input:focus {
    width: 100%;
    padding: .75rem;
    font-size: .85rem;
    margin-top: -.5rem;
    border: 1px #e1e1e1 solid;
    outline: none;
  }

  .balance-checker .field__input:hover,
  .balance-checker .field__input:active {
    border: 1px #000 solid;
  }

  .balance-checker .field--error .field__input {
    border: 1px #B00020 solid;
  }
</style>
